<template>
  <div class="tj-facet-list">
    <p class="mt-3 mb-1">
      <span class="text-overline font-weight-bold">{{titulo}}</span>

      <v-btn v-if="hasFacetsToShow" class="ml-1" icon x-small @click="onCloseAllClick" title="Ocultar todos">
        <v-icon>mdi-chevron-up</v-icon>
      </v-btn>

      <v-btn v-if="hasFacetsToShow" class="ml-1" icon x-small @click="onOpenAllClick" title="Exibir todos">
        <v-icon>mdi-chevron-down</v-icon>
      </v-btn>
    </p>

    <div v-for="facet in facets" :key="facet.key">
      <tj-facet
        v-if="facet.itens.length"
        class="mb-2"
        dense
        outlined
        :ref="facet.key"
        :closed="facet.closed"
        :titulo="facet.titulo"
        :itens="facet.itens"
        :chave="facet.key"
        @selection="onSelection"
        @closed="onClosed(facet, $event)"
      />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import "./tj-facet.vue";

export default Vue.component("tj-facet-list", {
  props: {
    facets: Array,
    titulo: {
      type: String,
      default: "Filtros"
    }
  },

  watch: {

  },

  computed: {
    hasFacetsToShow(){
      return this.facets.find(v => v.itens.length > 0) != null
    }
  },

  methods: {
    onOpenAllClick(){
      this.$emit("open-all")
    },

    onCloseAllClick(){
      this.$emit("close-all")
    },

    onSelection({ key, value, state }) {
      this.$emit("filter", { key, value, state });
    },

    onClosed(facet, state){
      this.$emit("close", facet, state)
    },

    changeState(facet, closed){
      const item = this.$refs[facet.key][0] //vue creates an array for each ref o.O
      item.changeState(!closed)
    }
  }
});
</script>
